import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "text-body" }
const _hoisted_3 = { class: "os-bold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { IonGrid } from "@ionic/vue";



import Event from "@/types/Event";

import compGeneralAppUtils from "@/composables/generalAppUtils";

export default /*#__PURE__*/_defineComponent({
  __name: 'EventCol',
  props: {
    event: {}
  },
  setup(__props: any) {

const { dateFormatting } = compGeneralAppUtils();



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonGrid), {
    class: "ion-no-padding",
    style: {"cursor":"pointer"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.event ? _ctx.event.flyer : 'https://via.placeholder.com/1080x1350',
        alt: 'Flyer - ' + _ctx.event?.name,
        class: "os-flyer mb-md os-rounded-border",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
        _ctx.$router.push(`/event/${_ctx.event?.customUrl ? _ctx.event.customUrl : _ctx.event?.id}`)
      ))
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.event ? _ctx.event.name : "Titulo del evento se vera aquí"), 1),
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.event
          ? _unref(dateFormatting)(_ctx.event.dates[0].startDate, "DD [de] MMMM YYYY")
          : "(día) del (mes) (año)"), 1)
      ])
    ]),
    _: 1
  }))
}
}

})